export enum ApiFailedReason {
	addToCart = 'addToCart',
	conflict = 'conflict',
	default = 'default',
	cartFetch = 'cartFetch',
	notValidAuth = 'notValidAuth',
	emailInUse = 'emailInUse',
}

export enum CustomizerRejectionType {
	customizer = 'customizer',
}
